import pickBy from 'lodash/pickBy';
import {
    getFilterSelectOption,
    getFilterValueOption,
} from '../../viewDashboards/widgets/widgetMenuUtils';
import { predicateValues } from '../constants/constants';

export function getClearedFilterValueOption(key, isInLabel) {
    return {
        [key]: {
            predicate: {
                textField: isInLabel,
                valueField: predicateValues.isIn,
            },
            values: [],
        },
    };
}

export function buildClearedPublisherFilterOptions(
    publisherFilters,
    predicateLabels
) {
    return publisherFilters.reduce((result, { filterKey }) => {
        const filterValueOption = getClearedFilterValueOption(
            filterKey,
            predicateLabels.isIn
        );

        return { ...result, ...filterValueOption };
    }, {});
}

export function buildPublishedFilterOptions(
    publisherFilters,
    rawDataForSelector,
    availableFilters,
    selectOptions,
    predicateLabels
) {
    return publisherFilters.reduce((result, { dataKey, filterKey }) => {
        const filterValue = rawDataForSelector[dataKey];

        const option = getFilterSelectOption(
            filterKey,
            availableFilters,
            filterValue,
            selectOptions
        );

        const filterValueOption = getFilterValueOption(
            filterKey,
            option,
            predicateLabels.isIn
        );

        return { ...result, ...filterValueOption };
    }, {});
}

export function applyPublishedFiltersToWidget(widget, publishedFilters) {
    if (!widget.subscriberFilterKeys) {
        return widget;
    }

    const filterValueOptions = pickBy(publishedFilters, (value, key) =>
        widget.subscriberFilterKeys.includes(key)
    );

    return {
        ...widget,
        filterValues: {
            ...widget.filterValues,
            ...filterValueOptions,
        },
    };
}
